import { useMemo } from "react";
import { useVoiceOutbound, useEmailOutbound } from "./";
import { InteractionType } from "@/common/types";
import { outboundInteractions } from "@/components/molecules/interactionMenu";
import { QueuesState, useQueuesStore } from "@/common/stores/nonpersistingStores/queues";

export interface AllowedOutboundData {
	disabledOutboundTypes: InteractionType[];
	canOutboundTypes: InteractionType[];
	possibleOutboundTypes: InteractionType[];
	isDataLoaded: boolean;
}

export const useAllowedOutbound = (): AllowedOutboundData => {
	const voice = useVoiceOutbound();
	const email = useEmailOutbound();
	const isDataLoaded = useQueuesStore(
		(state: QueuesState) => state.isDataLoaded
	);

	const disabledOutboundTypes = useMemo(() => {
		const result = [];

		if (!(voice.isOutboundPossible && voice.isOutboundAllowed)) {
			result.push(InteractionType.Call);
		}

		if (!(email.isOutboundPossible && email.isOutboundAllowed)) {
			result.push(InteractionType.Email);
		}

		return result;
	}, [voice.isOutboundPossible, voice.isOutboundAllowed, email.isOutboundPossible, email.isOutboundAllowed]);

	const possibleOutboundTypes = useMemo(() => {
		const result = [];

		if (voice.isOutboundPossible) {
			result.push(InteractionType.Call);
		}

		if (email.isOutboundPossible) {
			result.push(InteractionType.Email);
		}

		return result;
	}, [voice.isOutboundPossible, email.isOutboundPossible]);

	const canOutboundTypes = useMemo(() => {
		return (
			outboundInteractions.filter((x) => !disabledOutboundTypes.includes(x)) ??
			[]
		);
	}, [disabledOutboundTypes]);

	return {
		disabledOutboundTypes,
		canOutboundTypes,
		possibleOutboundTypes,
		isDataLoaded,
	};
};
